<div class="figure">
    <img *ngIf="travel?.image" [src]="travel.image" alt="travel image">
</div>

<div class="dashboard-content">


    <div class="travel-top-section-wrapper">
        <div class="travel-status-cancel">
            <div class="travel-header-item">
                <div class="header-item">
                    <div class="menu-toggle-wrapper">
                        <div class="breadcrumb">

                            <a class="link-page" (click)="redirectToPage('app.travels')">Путешествия <span
                                    class="lnr lnr-chevron-right"></span> <span
                                    class="lnr lnr-chevron-right second"></span></a>
                        </div>
                    </div>
                </div>

                <div class="client-title"> Путешествие в {{travel?.locationNames}}</div>
            </div>


            <div class="travel-status-cancel-row">
                <div class="travel-status fa waiting-confirmation"
                     *ngIf="[1,2,3,7,8].indexOf(travel?.status.id) >= 0"
                >
                    <span> </span> Ожидает подтверждения
                </div>

                <div class="travel-status fa confirmed"
                     *ngIf="[4].indexOf(travel?.status.id) >= 0"
                >
                    <span> </span> Подтверждено
                </div>

                <!--            [disabled]="[1,2].indexOf(travel?.status[0]?.id) < 0 || disablingBtn" -->
            </div>

            <div class="travel-status-cancel-row">

                <div class="travel-details-wrapper">
                    <div class="travel-item-details">
                        <div class="travels-item-dates">
                            <span class="lnr lnr-calendar-full"></span>
                            {{travel?.dateFrom | momentDate}} -  {{travel?.dateTo | momentDate}}
                        </div>
                        <div class="travels-item-people"
                             *ngIf="travel?.passengers?.length > 1 && travel?.passengers?.length < 5">
                            <span class="lnr lnr-users"></span>
                            {{travel?.passengers?.length}}  человека
                        </div>
                        <div class="travels-item-people"
                             *ngIf="travel?.passengers?.length === 1 || travel?.passengers?.length > 5">
                            <span class="lnr lnr-users"></span>
                            {{travel?.passengers?.length}}  человек
                        </div>
                    </div>

                </div>
            </div>

        </div>
        <div class="request-service-wrapper">
            <button class="button red-btn wide-btn" (click)="openRequestServicePopup('add')">
                Запросить доп. услугу
            </button>
            <div class="cancel-text">Если вы хотите отменить подтвержденное путешествие - свяжитесь пожалуйста с
                менеджером
            </div>
        </div>

    </div>


    <div class="line-separator"></div>

    <div class="program-passengers">

        <div class="program-block">
            <div class="global-block-title program-block-title">Расписание путешествия</div>
            <!--            <div class="info-text"> Расписание путешествия будет добавлено позже</div>-->
            <div *ngFor="let line of travel?.schedule; let i = index">
                <div class="schedule-accordeon">
                    <div class="chevron-expand" (click)="openItem(line)">
                        <span class="lnr lnr-chevron-right" [class.opened]="line.isOpened"></span>
                    </div>
                    <div class="schedule-header">
                        <div class="schedule-header-line">
                            <div class="schedule-header-item date-time">{{line.displayedDate}}</div>
                            <div class="schedule-header-item">{{line.location}}</div>
                        </div>
                        <div>{{formatName(line.displayedName)}}</div>
                    </div>

                </div>

                <div class="schedule-panel" [ngClass]="line.isOpened ? 'opened' :'closed' ">
                    <div *ngIf="line.serviceTypeId == 1">
                        <div class="comment-line"><span class="info-text">Тип номера: </span>{{line.roomType}} <span
                                class="info-text">Количество: </span> {{line.roomCount}}</div>
                        <div class="comment-line"><span class="info-text">Жильцы: </span>{{line.tenants}}</div>
                        <div class="comment-line"><span class="info-text">Комментарий: </span>{{line.comment}}</div>
                    </div>
                    <div *ngIf="line.serviceTypeId != 1 && line.serviceTypeId != 5">
                        <div class="comment-line">{{line.comment ? line.comment : 'Комментариев нет'}}</div>
                    </div>

                    <div *ngIf="line.serviceTypeId == 5" >
                        <ckeditor [disabled]="true" [editor]="Editor" [data]="line.comment ? line.comment : 'Комментариев нет'"
                                  [config]="{ toolbar: [ ] }" class="ckeditor-view-comment"></ckeditor>
                    </div>
                </div>


            </div>

        </div>


        <!----------------------------      Passengers       ----------------------->
        <div class="passengers-block">
            <div class="global-block-title">Путешественники</div>
            <div class="info-text"> Чтобы изменить состав путешественников, пожалуйста, свяжитесь с менеджером</div>
            <div class="passengers-block-item" *ngFor="let passenger of travel?.passengers; let i = index">

                <div class="name">{{passenger?.firstName}} {{passenger?.secondName}} {{passenger?.lastName}}</div>
                <div class="birthday">{{passenger?.birthday | momentDate}}</div>

            </div>
        </div>

        <!----------------------------     End Passengers       ----------------------->

    </div>

    <div class="line-separator"></div>


    <!----------------------------      Documents       ----------------------->
    <div class="global-block-title">Документы

    </div>


    <div class="file-download" *ngIf="fileDownloading">
        <span class="lnr lnr-sync"></span>
    </div>


    <div class="documents-list">
        <div>
            <ng-container *ngFor="let folder of travel?.folders; let folderIndex = index; let isOpened = false">
                <div *ngIf="folder.name !== 'Все документы'" class="documents-folder-item">

                    <!--                      <div class="name" > {{folder.name}} (Файлов: {{folder.files?.length ? folder.files.length : 0}})</div>-->
                    <div class="name"> {{folder.name}} </div>
                    <table class="table noborder">

                        <tbody>
                        <tr class="" *ngFor="let file of folder.files; let i = index">
                            <td><span class="blue-dot"></span></td>
                            <td width="30%" class='max-screen mid-screen'>
                                <div class="document-name">{{file.nameShort}}</div>
                                <div class="document-date">{{file.createdDate | momentDate}}</div>

                            </td>
                            <td class='max-screen mid-screen'></td>
                            <td class='max-screen mid-screen'>{{file.comment}}</td>
                            <td class='max-screen mid-screen'>
                                <button class="button blue-btn low-btn" (click)="downloadFile(file)">
                                    <span class="lnr lnr-download"> Скачать</span>
                                </button>
                            </td>

                            <td class='min-screen'>
                                <div class="first-last-name">
                                    <!--                                      <a (click)="downloadFile(file)">{{file.nameShort}}</a>-->
                                </div>
                                <div class="font-gray">{{file.createdDate | momentDate}}</div>
                                <div class="font-gray">{{file.comment}}</div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </ng-container>
        </div>
        <!----------------------------      End Documents       ----------------------->


        <app-request-service-popup [typeAction]="typeAction" *ngIf="showRequestServicePopup"
                                   (notify)="onNotify($event)"></app-request-service-popup>


        <app-confirm *ngIf="confirm" [data]="confirm" (notify)="onConfirmNotify($event)"></app-confirm>

